import JSONPretty from 'react-json-pretty';

export default {
  className: "MemberDetailLog",
  limit: 10,
  showExport: false,
  showCreate: false,
  showUpdate: false,
  showDelete: false,
  bypassAccess: true,
  columns: [
    {
      columnName: "objectId",
  		type: "string"
    },
    {
      columnName: "memberId",
  		type: "string"
    },
    {
      columnName: "isFresh",
  		type: "boolean"
    },
    {
      columnName: "from",
  		type: "string"
    },
    {
      columnName: "createMemberDetail_status",
  		type: "string"
    },
    // createMemberDetail_errorData
    {
      columnName: "setPersonContactID_status",
  		type: "string"
    },
    // setPersonContactID_errorData
    // setRMALFlag
    // setRMALFlag_status
    
    {
      columnName: "createdAt",
      columnLabel: "Date",
  		type: "Date",
      format: "MM/DD/YYYY hh:mm:ss A",
      show: true
    },
    {
      columnName: "updatedAt",
  		type: "Date",
      format: "MM/DD/YYYY hh:mm:ss A"
    }
  ]
}


// WEBPACK FOOTER //
// ./components/Logs/MemberDetailLog_schema.js